import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProjectLocationState {
    CreateProjectlocation: Record<string, any>; // Allowing dynamic object
  }
  
  // Initial state
  const initialState: ProjectLocationState = {
    CreateProjectlocation: {},
  };
  
  // Create Redux slice
  const projectLocationSlice = createSlice({
    name: "projectLocation",
    initialState,
    reducers: {
      setProjectLocation: (state, action: PayloadAction<Record<string, any>>) => {
        state.CreateProjectlocation = action.payload;
      },
      resetProjectLocation: (state) => {
        state.CreateProjectlocation = {};
      },
    },
  });
  
  // Export actions
  export const { setProjectLocation, resetProjectLocation } = projectLocationSlice.actions;
  export default projectLocationSlice.reducer;